<script setup lang="ts">
import { onMounted, ref } from 'vue';
import ClubRepository from '../../../js/repository/ClubRepository.js';
import { SphButton } from '@/components/base/button';
import { useNotifications } from '@/composables/notifications';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<{
    clubId: number
}>();

const resets = defineModel<{ filterFlagId: number | null, hour: number }[]>('resets', { required: true });

const { notify } = useNotifications();
const filterFlags = ref<{ id: number, value: string }[]>([]);

onMounted(() => {
    ClubRepository.findMemberFilterFlags(props.clubId)
        .then((flags) => filterFlags.value = flags)
        .catch(() => notify.error('error.loadingData'));
});

function isTakenByAnotherRow(filterFlagId: number, index: number) {
    return resets.value.some((reset, otherIndex) => otherIndex !== index && reset.filterFlagId === filterFlagId);
}

function addRow() {
    resets.value.push({ filterFlagId: null, hour: 0 });
}

function removeRow(index: number) {
    resets.value.splice(index, 1);
}
</script>

<template>
    <div>
        <p class="kgr-text kgr-text--small">
            {{ $t('Die hier gewählten Auswahlkriterien werden täglich zur angegebenen Stunde bei allen Einträgen entfernt.') }}
        </p>
        <div
            v-for="(reset, index) in resets"
            :key="index"
            class="mt-2 flex items-center gap-2"
        >
            <select
                v-model="reset.filterFlagId"
                class="kgr-select"
                :aria-label="$t('Name des Auswahlkriteriums')"
            >
                <option :value="null">
                    {{ $t('pleaseChooseAnOption') }}
                </option>
                <option
                    v-for="filterFlag in filterFlags"
                    :key="filterFlag.id"
                    :value="filterFlag.id"
                    :disabled="isTakenByAnotherRow(filterFlag.id, index)"
                >
                    {{ filterFlag.value }}
                </option>
            </select>
            <input
                v-model.number="reset.hour"
                type="number"
                class="kgr-input w-20! flex-none!"
                min="0"
                max="23"
                :aria-label="$t('Stunde')"
            />
            <sph-button
                @click="removeRow(index)"
            >
                {{ $t('Entfernen') }}
            </sph-button>
        </div>
        <sph-button
            class="mt-4"
            @click="addRow"
        >
            {{ $t('Hinzufügen') }}
        </sph-button>
    </div>
</template>
